import { render, staticRenderFns } from "./PrivacyPolicies.vue?vue&type=template&id=0b306fd2&scoped=true&"
import script from "./PrivacyPolicies.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicies.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicies.vue?vue&type=style&index=0&id=0b306fd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b306fd2",
  null
  
)

export default component.exports